// Portal › Kullanıcılar — >1100 px tablo düzeni (ClientUsers.tsx ≤600 satır kuralı için ayrıldı).
// Sütunlar: kullanıcı · Rol (Süper Admin / Admin / Kullanıcı — v2) · KPI erişimi · form daveti ·
// durum. Kopyalar lib/client-admin-copy.ts TEK kaynak.

import type { ClientUser } from "@mahir/shared";
import { CLIENT_ADMIN_COPY as C } from "../../lib/client-admin-copy";
import { AccessSummary, roleLabelOf, StatusPill } from "./ClientUserCard";

interface Props {
  users: ClientUser[];
  selectedId: string | null;
  meId: string | null;
  actions: (u: ClientUser, isSelected: boolean) => JSX.Element;
}

export function ClientUserTable({ users, selectedId, meId, actions }: Props): JSX.Element {
  return (
    <div style={{ overflowX: "auto" }}>
      <table className="w-full text-sm" style={{ borderCollapse: "collapse", minWidth: 820 }}>
        <thead>
          <tr
            style={{
              fontSize: "0.68rem",
              letterSpacing: "0.08em",
              color: "var(--color-text-3)",
              textAlign: "left",
              borderTop: "1px solid var(--color-border)",
              borderBottom: "1px solid var(--color-border)",
            }}
          >
            <th className="px-4 py-2 font-semibold">{C.columns.user}</th>
            <th className="px-4 py-2 font-semibold">{C.admins.roleColumn}</th>
            <th className="px-4 py-2 font-semibold">{C.columns.kpi}</th>
            <th className="px-4 py-2 font-semibold">{C.columns.forms}</th>
            <th className="px-4 py-2 font-semibold">{C.columns.status}</th>
            <th className="px-4 py-2" />
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td
                colSpan={6}
                className="px-4 py-6 text-center"
                style={{ color: "var(--color-text-3)" }}
              >
                {C.empty.noMatch}
              </td>
            </tr>
          ) : (
            users.map((u) => {
              const closed = u.status === "closed";
              const isSelected = u.id === selectedId;
              return (
                <tr
                  key={u.id}
                  style={{
                    borderBottom: "1px solid var(--color-border)",
                    background: isSelected
                      ? "color-mix(in srgb, var(--color-primary) 5%, white)"
                      : undefined,
                    opacity: closed ? 0.6 : 1,
                  }}
                >
                  <td className="px-4 py-3 align-top">
                    <div style={{ color: "var(--color-text)", fontWeight: 600 }}>
                      {u.fullName}
                      {u.id === meId ? (
                        <span className="ml-2 text-xs" style={{ color: "var(--color-primary)" }}>
                          {C.youTag}
                        </span>
                      ) : null}
                    </div>
                    <div className="text-xs" style={{ color: "var(--color-text-3)" }}>
                      {u.email}
                    </div>
                  </td>
                  <td className="px-4 py-3 align-top" style={{ color: "var(--color-text-2)" }}>
                    {roleLabelOf(u)}
                  </td>
                  <td className="px-4 py-3 align-top">
                    <AccessSummary user={u} />
                  </td>
                  <td className="px-4 py-3 align-top" style={{ color: "var(--color-text-2)" }}>
                    {u.projects.length === 0
                      ? C.forms.none
                      : u.projects.map((p) => (
                          <div key={p.projectId}>
                            {p.label} · {C.forms.status[p.participantStatus] ?? p.participantStatus}
                          </div>
                        ))}
                  </td>
                  <td className="px-4 py-3 align-top">
                    <StatusPill status={u.status} />
                  </td>
                  <td className="px-4 py-3 align-top text-right whitespace-nowrap">
                    {actions(u, isSelected)}
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}
